import { CardInfoTranslation } from "@models/card-info-translation.model";
import { useTranslation } from "react-i18next";
import CardInfoCard from "@components/CardInfo";
import { useEffect, useState } from "react";
import titleService from "@services/title.service";
import { useLocation } from "react-router-dom";
import PageHeader from "./PageHeader";
import InputComponent from "./InputComponent";

export default function CardInfoListPage(props: { cardInfoList: CardInfoTranslation[] | undefined }) {
  const { t } = useTranslation();
  const [pageTitle, setPageTitle] = useState('');
  const location = useLocation();
  const [filteredList, setFilteredList] = useState<CardInfoTranslation[]>(props.cardInfoList ?? []);

  useEffect(() => {
    setFilteredList(props.cardInfoList ?? []);
  }, [props.cardInfoList]);

  useEffect(() => {
    const fetchData = async (qrCode: string, cardInfoId: number) => {
      const title = await titleService.getTitle(qrCode, cardInfoId);
      setPageTitle(title);
    };

    const segments = location.pathname.split('/').filter(Boolean);
    const qrCodeId = segments[0] ?? '';
    const lastSeg = segments.at(-1) ?? '';
    const parsedId = parseInt(lastSeg, 10);
    const cardInfoId = Number.isNaN(parsedId) ? 0 : parsedId;

    fetchData(qrCodeId, cardInfoId);
  }, [location.pathname, props.cardInfoList]);

  if (!props.cardInfoList) return null
  const { cardInfoList } = props

  return (
    <div className="mx-3">
      <div className="sticky-top sticky-header border-bottom border-light">
        <PageHeader pageTitle={pageTitle} flagSearch={false} flag={false}/>
        <div className="col-12">
          <InputComponent list={cardInfoList} setFilteredList={setFilteredList} isAccomodation={false}/>
        </div>
      </div>
      <div className="container">
        <div className="row row-cols-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-6 row-cols-xxl-7 g-4 mt-4">
          {filteredList.map((el) => (
            <div key={`filtered-${el.id}`} className="col-4 p-1">
              <CardInfoCard data={el} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}